<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429976374_toc01#toctitle2" id="title2"><span><strong class="b">PART 1</strong></span></a></div>
<div class="subtitle-part"><strong class="b">Cousin Cash Comes to Paris</strong></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429976374_p01.vue?5a825af8